import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import ConfirmDialog from "@/components/ConfirmDialog";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Tattoos from "@/pages/Tattoos";
import Financial from "@/pages/Financial";
import Insights from "@/pages/Insights";
import Reminders from "@/pages/Reminders";
import PostCare from "@/pages/PostCare";
import Draw from "@/pages/Draw";
import Settings from "@/pages/Settings";
import Ranking from "@/pages/Ranking";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/ranking" element={<Ranking />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/clientes" element={<Clients />} />
            <Route path="/clientes/:id" element={<ClientDetail />} />
            <Route path="/tatuagens" element={<Tattoos />} />
            <Route path="/financeiro" element={<Financial />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/lembretes" element={<Reminders />} />
            <Route path="/pos-atendimento" element={<PostCare />} />
            <Route path="/sorteio" element={<Draw />} />
            <Route path="/configuracoes" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ConfirmDialog />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
